<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('alert_push')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :preview="record.id"
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <alert-push-modal @ok="modalFormOk" ref="modalForm"></alert-push-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AlertPushModal from './modules/AlertPushModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'AlertPushList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      AlertPushModal
    },
    data () {
      return {
        description: 'alert_push管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '名称',
            align: "center",
            dataIndex: 'name'
          },
          {
            title: '推送类型',
            align: "center",
            dataIndex: 'type_dictText'
          },
          {
            title: '推送目标',
            align: "center",
            dataIndex: 'target'
          },
          //   {
          //     title: '租户id',
          //     align: "center",
          //     dataIndex: 'tenantId'
          //   },
          //   {
          //     title: '公司id',
          //     align: "center",
          //     dataIndex: 'orgId'
          //   },
          //   {
          //     title: '删除状态',
          //     align: "center",
          //     dataIndex: 'delFlag'
          //   },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/rule/alertPush/list",
          delete: "/rule/alertPush/delete",
          deleteBatch: "/rule/alertPush/deleteBatch",
          exportXlsUrl: "/rule/alertPush/exportXls",
          importExcelUrl: "rule/alertPush/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'name', text: '名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'type', text: '推送类型', dictCode: 'push_type' })
        fieldList.push({ type: 'string', value: 'target', text: '推送目标', dictCode: '' })
        fieldList.push({ type: 'int', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>